import { openApi } from "./api";

// Doc 0446 — rutas públicas: quien olvidó la contraseña no tiene sesión.
export const requestPasswordReset = (email) =>
  openApi.post("/auth/password/forgot", { email });

export const checkPasswordResetToken = (token) =>
  openApi.get("/auth/password/reset/check", { params: { token } });

export const resetPassword = (token, password) =>
  openApi.post("/auth/password/reset", { token, password });
